import { apiClient } from "./apiClient"

/****************************************************************************
 * 
 * Installations
 * 
 ***************************************************************************/
export const installationApi = {
    /**
     * Fetch Installations for a given business entity
     * @param {string} businessEntityId - The Business Entity ID
     * @param {object} config - The application config object
     * @param {object} accessToken - The logged in user's accessToken
     * @returns {Promise} - The Installation as a Promise
     */
    fetchInstallationList: async (businessEntityId, config, accessToken, includeChildren = false) => {
        const url = `${config.managementApiUrl}/businessentities/${businessEntityId}/installations${includeChildren ? '?includeChildAccounts=true' : ''}`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET",
                headers: {
                    'Clientid': 4
                }
            },
            async (response) => {
                return await response.json().then(
                    (item) => {
                        return item.installation
                    }
                )
            }
        )
    },
    /**
     * Create Installations for a given business entity
     * @param {string} businessEntityId - The Business Entity ID
     * @param {object} config - The application config object
     * @param {object} installationManifest - The installation manifest
     * @param {object} accessToken - The logged in user's accessToken
     * @returns {Promise} - The Installation as a Promise
     */
    createInstallation: async (businessEntityId, config, installationManifest, accessToken) => {
        const url = `${config.managementApiUrl}/businessentities/${businessEntityId}/installations`
        return await apiClient(url, accessToken, {
            method: "POST",
            headers: {
                'ClientId': '4'
            },
            body: JSON.stringify(installationManifest)
        })
    },
    /**
     * Downlaod Install Package
     * @param {object} config - The application config object
     * @param {object} verificationId - The Verification Id of the requested download package
     * @returns {Promise} - The update result as a Promise
     */
    downloadInstallerPackage: async (config, verificationId) => {
        const url = `${config.managementApiUrl}/installations/packagezip?verificationId=${verificationId}`
        return await apiClient(
            url,
            null,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/octet"
                }
            },
            async (response) => {
                return await response.arrayBuffer().then(
                    (result) => {
                        return result
                    }
                )
            }
        )
    },
    /**
     * Update the UTG version of an existing Installation. The verification id is preserved by the service,
     * so any documentation referencing it remains accurate.
     * @param {string} businessEntityId - The Business Entity ID
     * @param {string} installationId - The id of the installation to update
     * @param {object} config - The application config object
     * @param {object} installation - The installation carrying the updated utgVersion
     * @param {object} accessToken - The logged in user's accessToken
     * @returns {Promise} - The updated Installation as a Promise
     */
    updateInstallation: async (businessEntityId, installationId, config, installation, accessToken) => {
        const url = `${config.managementApiUrl}/businessentities/${businessEntityId}/installations/${installationId}`
        return await apiClient(url, accessToken, {
            method: "PUT",
            headers: {
                'ClientId': '4'
            },
            body: JSON.stringify(installation)
        })
    },
    /**
     * Deactivate Installation
     * @param {object} config - The application config object
     * @param {string} beId - The business entity id of the installation to deactivate
     * @param {string} installationId = The id of the installation to deactivate
     * @param {object} accessToken - The logged in user's accessToken
     * @returns {Promise} - The update result as a Promise
     */
    deactivateInstallation: async (config, beId, installationId, accessToken) => {
        const url = `${config.managementApiUrl}/businessentities/${beId}/installations/${installationId}`
        return await apiClient(
            url,
            accessToken,
            {
                method: "DELETE",
                headers: {
                    'Clientid': '4'
                }
            },
            (response) => {
                return response
            }
        )
    }
}